import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;
let lastPresenceReportAt = 0;
let lastPresenceScreen = '';
let lastPresenceAction = '';

export const initSocket = (token: string) => {
  if (socket) return socket;

  const API_URL = import.meta.env.VITE_API_URL || '';
  
  // We extract the base URL if VITE_API_URL contains a path like '/api'
  const baseURL = API_URL.replace(/\/api\/?$/, '');

  socket = io(baseURL || undefined, {
    auth: { token },
    transports: ['websocket', 'polling'],
    upgrade: true,
    timeout: 20000,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    console.log('🔌 Socket conectado:', socket?.id);
  });

  socket.on('disconnect', () => {
    console.log('🔌 Socket desconectado');
  });

  socket.on('connect_error', (err) => {
    console.warn('⚠️ Erro de conexão no DB/Socket:', err.message);
  });

  return socket;
};

export const getSocket = () => {
  if (!socket) {
    console.warn('⚠️ Socket não inicializado. Chame initSocket(token) primeiro.');
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  lastPresenceReportAt = 0;
  lastPresenceScreen = '';
  lastPresenceAction = '';
};

export const reportPresenceActivity = ({
  screen,
  action,
  force = false
}: {
  screen?: string | null;
  action?: string | null;
  force?: boolean;
}) => {
  if (!socket?.connected) return;

  const normalizedScreen = String(screen || '').trim().slice(0, 500);
  const normalizedAction = String(action || '').trim().slice(0, 255);
  const now = Date.now();
  const unchanged = normalizedScreen === lastPresenceScreen && normalizedAction === lastPresenceAction;
  const hasPayload = Boolean(normalizedScreen || normalizedAction);

  if (!force && now - lastPresenceReportAt < 25000 && (!hasPayload || unchanged)) {
    return;
  }

  lastPresenceReportAt = now;
  if (normalizedScreen) lastPresenceScreen = normalizedScreen;
  if (normalizedAction) lastPresenceAction = normalizedAction;
  socket.emit('crm_presence_activity', {
    screen: normalizedScreen || undefined,
    action: normalizedAction || undefined
  });
};

export const reportPresenceLogout = (reason = 'explicit_logout') => {
  if (!socket?.connected) return;
  socket.emit('crm_presence_logout', { reason });
};
